module.exports = __webpack_public_path__ + "static/media/reuters.9ce22ab7.png";